import { render, staticRenderFns } from "./TrademarkViennaClassesList.vue?vue&type=template&id=8fa4a8ea&"
import script from "./TrademarkViennaClassesList.vue?vue&type=script&lang=js&"
export * from "./TrademarkViennaClassesList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkViennaClassesList.vue?vue&type=style&index=0&id=8fa4a8ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports